module.exports = __webpack_public_path__ + "media/promo/velle/images/top_products/prod_1__mob-4081d0504656013fb1659b3b17ed602f.png";